function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 5H4.16667H17.5",
  stroke: "#EB5757",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5832 4.99996C16.5832 4.58574 16.2474 4.24996 15.8332 4.24996C15.419 4.24996 15.0832 4.58574 15.0832 4.99996H16.5832ZM4.9165 4.99996C4.9165 4.58574 4.58072 4.24996 4.1665 4.24996C3.75229 4.24996 3.4165 4.58574 3.4165 4.99996H4.9165ZM5.91651 4.99996C5.91651 5.41417 6.25229 5.74996 6.66651 5.74996C7.08072 5.74996 7.41651 5.41417 7.41651 4.99996H5.91651ZM12.5832 4.99996C12.5832 5.41417 12.919 5.74996 13.3332 5.74996C13.7474 5.74996 14.0832 5.41417 14.0832 4.99996H12.5832ZM15.0832 4.99996V16.6666H16.5832V4.99996H15.0832ZM15.0832 16.6666C15.0832 17.1729 14.6728 17.5833 14.1665 17.5833V19.0833C15.5012 19.0833 16.5832 18.0013 16.5832 16.6666H15.0832ZM14.1665 17.5833H5.83317V19.0833H14.1665V17.5833ZM5.83317 17.5833C5.32691 17.5833 4.9165 17.1729 4.9165 16.6666H3.4165C3.4165 18.0013 4.49848 19.0833 5.83317 19.0833V17.5833ZM4.9165 16.6666V4.99996H3.4165V16.6666H4.9165ZM7.41651 4.99996V3.33329H5.91651V4.99996H7.41651ZM7.41651 3.33329C7.41651 2.82703 7.82691 2.41663 8.33317 2.41663V0.916626C6.99848 0.916626 5.91651 1.9986 5.91651 3.33329H7.41651ZM8.33317 2.41663H11.6665V0.916626H8.33317V2.41663ZM11.6665 2.41663C12.1728 2.41663 12.5832 2.82703 12.5832 3.33329H14.0832C14.0832 1.9986 13.0012 0.916626 11.6665 0.916626V2.41663ZM12.5832 3.33329V4.99996H14.0832V3.33329H12.5832Z",
  fill: "#EB5757"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.3335 9.16663V14.1666",
  stroke: "#EB5757",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6665 9.16663V14.1666",
  stroke: "#EB5757",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgTrashRed = function SvgTrashRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrashRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-red.fafedc9d.svg";
export { ForwardRef as ReactComponent };